import { ChangeDetectorRef, Component, Renderer2, NgZone } from '@angular/core';
import { CmsComponentData, NavigationNode, NavigationService } from '@spartacus/storefront';
import { CmsNavigationComponent, CmsLinkComponent, AuthService, User, UserIdService, CmsBannerComponent, OccConfig, BaseSiteService} from '@spartacus/core';
import { BehaviorSubject, Observable, Subscription, filter, forkJoin, map, shareReplay, take } from 'rxjs';
import { ContentService } from '../../spartacus/services/content.service';
import { UserInfoService } from '../../spartacus/services/user-info.service';
import { NavigationEnd, Router } from '@angular/router';
import { CsAgentAuthService } from '@spartacus/asm/root';
import { JoinAccountService  } from '../../shared';
import { HttpClient } from '@angular/common/http';




@Component({
    selector: 'app-top-header',
    templateUrl: './top-header.component.html',
    styleUrls: ['./top-header.component.scss'],
    standalone: false
})

  export class TopHeaderComponent {
    toggleListView:boolean=false;
    node$: Observable<NavigationNode | null | undefined | any> = this.service.createNavigation(
      this.componentData?.data$
    ).pipe(shareReplay(1));
    isCartExist: Observable<any> = this.userInfoService.cartExist$;
    styleClass$: Observable<string | undefined> = this.componentData.data$.pipe(
      map((d) => d?.styleClass)
    );
    
  navigation: any=[];
  mobnav:any=[];
  rbavarible:any;
  Ukclass: boolean = false;
  iconClass:string="fa fa-bars";
  isOpen: boolean=false;
  afluriaurl: any;
  fluadurl: any;
  flucelvaxurl: any;
  isUserLoggedIn: boolean=false;
  publicpage:boolean=false;
  userInfo: any;
  glyphiconIcon = "glyphicon-menu-down";
  iconClassMob: string="fa fa-bars";
  subscription:Subscription[]=[];
  flucelvaxPdf!: Observable<any>;
  fluadPdf!: Observable<any>;
  afluriaPdf!: Observable<any>;
  currentSite: string | undefined;
  multipleSoldTos: any;
  selectedAccount:string='';
  iconUkAcc: string="fa-angle-down";
  isCollapsed: boolean=false;
  searchText:string="";
  filteredMultipleSoldTos: any;
  asmUser: boolean = false;
  asmEnabled: boolean = false;
  asmAgentLoggedIn: boolean = false;
  customerEmulated: boolean = false;
  newuserData:boolean = true;
  multiplerun:boolean=false;
  private subscriptionJoinAccount: Subscription | undefined; // Store subscripti
  isSearchByProfile: boolean=false;
  isDropdownOpen = false;
  filteredNavigation: any[] = [];
  siteLogos: any[] = [];
  remainingNavigation: any[] = [];
  ukNavigation: any[] = [];
  ukNavigation2: any[] = [];
  private ukLogosSubject = new BehaviorSubject<any[]>([]);
  ukSiteLogos$ = this.ukLogosSubject.asObservable();
  private usLogosSubject = new BehaviorSubject<any[]>([]);
  usSiteLogos$ = this.usLogosSubject.asObservable();


    constructor(
      public userInfoService:UserInfoService,public component: CmsComponentData<CmsBannerComponent>,
      private cdr:ChangeDetectorRef,private authService: AuthService,
      protected componentData: CmsComponentData<CmsNavigationComponent>,
      protected service: NavigationService, protected _mobmenu:ContentService,
      protected csAgentAuthService: CsAgentAuthService,
      protected config: OccConfig,private baseSiteService:BaseSiteService,private router: Router,private renderer:Renderer2,
      private joinAccountService: JoinAccountService,public contentService: ContentService,
      private ngZone: NgZone,private http: HttpClient
    ) {

        // if(this.csAgentAuthService.isCustomerSupportAgentLoggedIn() && this.csAgentAuthService.isCustomerEmulated()){
        //   console.log("asm agent");
        // }
        this.router.events.subscribe(event => { if (event instanceof NavigationEnd) { if (event.urlAfterRedirects.includes('/createprofile')) { this.resetErrorIcons(); } } });
                
    }
  resetErrorIcons() {
  const icons = document.querySelectorAll('.error_icon');
  icons.forEach(icon => this.renderer.removeStyle(icon, 'display'));
}

   
reloadOnlyIfAlreadyOnCreateProfile(node: any, event: MouseEvent): void {
  // If this is a dropdown parent, do nothing (no navigation/reload).
  if (node?.children && node.children.length) {
    return;
  }
 
  // Determine the target route from your existing routerLink condition
  const targetRoute: string =
    (this as any).isUserLoggedIn && !(this as any).userInfo?.webEnabled
      ? '/register/join-account'
      : (typeof node?.url === 'string' ? node.url : '');
 
  // We only care about the current path’s tail: `/createprofile`
  const currentPath = window.location.pathname.replace(/\/+$/, ''); // trim trailing slash
  const isOnCreateProfile = currentPath.endsWith('/createprofile');
 
  // If NOT on /createprofile → do nothing → SPA navigation happens via [routerLink]
  if (!isOnCreateProfile) {
    return;
  }
 
  // From here: we ARE already on /createprofile.
  // If the target is "flu-vaccine-resources", DO NOT hard reload (let SPA navigation happen).
  if (typeof targetRoute === 'string' && targetRoute.includes('flu-vaccine-resources')) {
    // Do nothing; allow routerLink to navigate as usual.
    return;
  }
 
  // Otherwise, perform a HARD reload to the intended absolute URL (environment-agnostic).
  // Build absolute URL with current site context: /{baseSite}/{currency}/{language}
  // Examples you've shared look like: /seqirusb2b-flu360/USD/en/...
  event.preventDefault();
  event.stopPropagation();
 
  // Derive context prefix from current path (works across localhost/dev/dev3/stg/prod)
  // e.g., /seqirusb2b-flu360/USD/en/createprofile  ->  /seqirusb2b-flu360/USD/en
  const segs = currentPath.split('/').filter(Boolean);
  let contextPrefix = '';
  if (segs.length >= 3) {
    const baseSite = segs[0];
    const s1 = segs[1];
    const s2 = segs[2];
 
    // Heuristics: currency is usually 3 uppercase letters (USD/EUR/etc),
    // language is usually en / en-US / fr / de...
    const isCurrency = (s: string) => /^[A-Z]{3}$/.test(s);
    const isLanguage = (s: string) => /^[a-z]{2}(-[A-Za-z0-9]+)?$/.test(s);
 
    if ((isCurrency(s1) && isLanguage(s2)) || (isLanguage(s1) && isCurrency(s2))) {
      contextPrefix = `/${baseSite}/${s1}/${s2}`;
    } else {
      // Fallback: first 3 segments as-is
      contextPrefix = `/${segs.slice(0, 3).join('/')}`;
    }
  }
 
  // Normalize target route to an absolute URL (keep external as-is)
  let absoluteUrl = window.location.href; // default to current if targetRoute is empty
  if (targetRoute) {
    if (/^https?:\/\//i.test(targetRoute)) {
      // Absolute external link → just go there (hard reload will still happen)
      absoluteUrl = targetRoute;
    } else {
      // Internal route: ensure leading slash
      const normalized = targetRoute.startsWith('/') ? targetRoute : `/${targetRoute}`;
 
      // If it already appears to include the context prefix, use it as-is; else prepend context
      const pathWithContext = contextPrefix && normalized.startsWith(contextPrefix + '/')
        ? normalized
        : `${contextPrefix}${normalized}`;
 
      absoluteUrl = `${window.location.origin}${pathWithContext}`;
    }
  }
 
  // Hard reload to the computed absolute URL
  window.location.assign(absoluteUrl); // or: window.location.href = absoluteUrl;
}

reloadAfterLogout() {
  if (this.isUserLoggedIn && !this.userInfo?.webEnabled) {
    // Delay ensures the router finishes navigating to /logout first
    setTimeout(() => {
      window.location.reload();
    }, 2000);
  }
}

    closeMobileMenu() {
      this._mobmenu.togglemabmenu = false;
      const temp = <HTMLElement>document.getElementsByClassName("mob_exp_menu")[0];
      if (temp) {
        temp.style.display = "none";
      }
      this.iconClass = 'fa fa-bars';
      this.isOpen = false;
    }
    

    //multipleSoldTos$= this.userInfoService.fetchMultipleSoldToForUser();
    showStatus() {
     
      this.asmEnabled = localStorage.getItem('showASM') === 'true';
      this.isSearchByProfile = localStorage.getItem('isSearchByProfile') == 'true' ? true:false;
      this.csAgentAuthService.isCustomerSupportAgentLoggedIn().subscribe(i => {
          this.asmAgentLoggedIn = i;
      });
      this.csAgentAuthService.isCustomerEmulated().subscribe(res => {
        this.customerEmulated = res;
      });
      if(this.asmEnabled && this.asmAgentLoggedIn && this.customerEmulated) {
        return false;
      }
      return true;
    }

     goMyprofile(){
      /* this.router.navigate(['/my-profile']).then(() => {
        window.location.reload();
      }); */
      this.router.navigate(['/my-profile'])
     }

     logOutredirect(){
      this.router.navigate(['/logout'])
     }

    // fetchPIPdfData(){
    //   if(this.currentSite == 'seqirusb2b-flu360'){
    //     this.afluriaPdf= this._mobmenu.getNavigation("AfluriaHeaderLink").pipe(shareReplay(1));
    //     this.fluadPdf= this._mobmenu.getNavigation("FluadHeaderLink").pipe(shareReplay(1));
    //     this.flucelvaxPdf= this._mobmenu.getNavigation("FlucelvaxHeaderLink").pipe(shareReplay(1));

    //     this.afluriaPdf.pipe(map(val=> val.media?.url)).subscribe(res => {
    //       this.afluriaurl = res;
    //   });
    //   this.fluadPdf.pipe(map(val=> val.media?.url)).subscribe(res => {
    //     this.fluadurl = res;
    //   });
    //   this.flucelvaxPdf.pipe(map(val=> val.media?.url)).subscribe(res => {
    //     this.flucelvaxurl = res;
    //   });
    //   }
    // }




    openList(){
      this.toggleListView=!this.toggleListView;

    }
    toggleSlideUkAcc(){
      if(this.iconUkAcc === 'fa-angle-down'){
        this.iconUkAcc = 'fa-angle-up';
        this.isCollapsed=true;
      }
      else{
        this.iconUkAcc='fa-angle-down';
        this.isCollapsed=false;

      }
    }
    toggleSlideLoggedInMob(){
      if(this.iconClassMob === 'fa fa-bars'){
        this.iconClassMob = 'fa-solid fa-xmark';
        this.isOpen=true;
        this.userInfoService.setMobileHeader(true);
      }
      else{
        this.iconClassMob = 'fa fa-bars';
        this.isOpen=false;
        this.userInfoService.setMobileHeader(false);
      }
    }
    // toggleSlide(){
    //   this._mobmenu.togglemabmenu=!this._mobmenu.togglemabmenu;

    //   const temp= <HTMLElement> document.getElementsByClassName("mob_exp_menu")[1];

    //   if(this._mobmenu.togglemabmenu){
    //     temp.style.display="block";
    //   }
    //   else{
    //     temp.style.display="none";
    //   }
    //   if(this.iconClass === 'fa fa-bars'){
    //     this.iconClass = 'fa-solid fa-xmark';
    //     this.isOpen=true;
    //   }
    //   else{
    //     this.iconClass = 'fa fa-bars';
    //     this.isOpen=false;
    //   }
    // }
    toggleSlide() {
      this._mobmenu.togglemabmenu = !this._mobmenu.togglemabmenu;
    
      const temp = <HTMLElement>document.getElementsByClassName("mob_exp_menu")[0];
    
      if (this._mobmenu.togglemabmenu) {
        temp.style.display = "block";
        this.iconClass = 'fa-solid fa-xmark';
        this.isOpen = true;
      } else {
        this.closeMobileMenu();
      }
    }    

    // setDifferentTopHeader(){
    //   const temp= <HTMLElement> document.getElementsByClassName("TopHeaderNavSlot")[0];
    //   if(temp){
    //   if(this.isUserLoggedIn && this.userInfo.webEnabled){
    //       temp.style.display='none';
    //   }
    //   else if((!this.isUserLoggedIn) || ((this.isUserLoggedIn) && (!this.userInfo.webEnabled))){
    //     temp.style.display='block';
    //     }
    //   }
    // }
    setDifferentBottomHeader(){
    //  const temp= <HTMLElement> document.getElementsByClassName("BottomHeaderSlot")[1];
      const body=<HTMLElement>document.querySelector("body");
      if(body){
      if(this.isUserLoggedIn && this.userInfo.webEnabled){
        body.classList.add("loggedin");
        body.classList.remove("non-webEnabled");
        this.cdr.detectChanges();
        // temp.style.display='none';
      }
      else if((this.isUserLoggedIn) && (!this.userInfo.webEnabled)){
        body.classList.add("non-webEnabled");
        body.classList.remove("loggedin");
        this.cdr.detectChanges();
        // temp.style.display='none';
      }
      else if((!this.isUserLoggedIn)){
        body.classList.remove("loggedin");
        body.classList.remove("non-webEnabled");
        this.cdr.detectChanges();
        // temp.style.display='none';
        }
        else{
        body.classList.remove("loggedin");
        body.classList.remove("non-webEnabled");
        this.cdr.detectChanges();
        // temp.style.display='none';
        }
      }
    }

    

    ngOnInit(){
        const hrefvalue=window.location.href?.split('/')
      if(hrefvalue[hrefvalue?.length-1]=='public'){
    this.publicpage=true
    console.log(this.publicpage)
      }else{
        this.publicpage=false
      }
      this.baseSiteService.getActive().subscribe((siteId) => {
        this.currentSite = siteId;
      });

    
      
      this.isSearchByProfile = localStorage.getItem('isSearchByProfile') == 'true' ? true:false;
      this.subscriptionJoinAccount = this.joinAccountService.formSubmitted$.subscribe(() => {
        this.updateMultipleSoldToHeader();
      });



      const body=<HTMLElement>document.querySelector("body");
      if(this.currentSite=='seqirusb2b-uk'){
        body.classList.add("seqirusb2b-uk");
      }else{
        body.classList.add("seqirusb2b-flu360");
      }
      this.router.events.subscribe((event) => {

        if(event instanceof NavigationEnd){
          this.closeMobileMenu();
          this.closeDropdown(); // Close the dropdown
          this.updateUserData();
          this.updateMultipleSoldToHeader();
          this.isCollapsed=false;
          this.iconUkAcc='fa-angle-down';
          this.cdr.detectChanges();
        }
      })


      // if(!this.afluriaurl && !this.fluadurl && !this.flucelvaxurl){
     //this.fetchPIPdfData();
      // }
     this.updateUserData();
     // this.toprbafunction();
      this.cdr.detectChanges();
      this.node$.subscribe((res:any)=>{
        if(res){

          if(res.title=='For UK Healthcare Professionals Only' || res.title=='For UK Patients and members of the public'){


            this.navigation=res.children[0].children;
            this.Ukclass = true;

          }

          if(res.title=='For US Healthcare Professionals Only' && this.currentSite == 'seqirusb2b-flu360'){
            let a=res.children[0].children.find((x:any)=>x.title==='For US Healthcare Professionals Only');
           
            let b=res.children[0].children.find((x:any)=>x.title==='Prescribing Information');
         

            this.navigation=res.children[0].children;
            this.navigation.splice(this.navigation.findIndex((x:any)=>x.title==='For US Healthcare Professionals Only') , 1);
            this.navigation.unshift(a)
          }
          //removed mobnav, handled in HTML
         /*  if(this.currentSite == 'seqirusb2b-flu360'){
            let a=res.children[0].children.find((x:any)=>x.title==='Prescribing Information');
         
            this.mobnav = res.children[0].children;
           
          } */
          let count = 0;
          res?.children[0]?.children?.forEach((element:any )=> {
            if(element.title =='Log In' || element.title =='Log in'){
              count++;
              element['value']=count;
            }
           
          });
        }
      })

      if(this.currentSite == 'seqirusb2b-uk'){
       this.updateMultipleSoldToHeader();
      }

      
     
  this.node$.subscribe((response: any) => {
    const allowedTitlesForUK = [ 'Log in'];

    this.ukNavigation = (response?.children?.[0]?.children || []).filter((nav: any) =>
      allowedTitlesForUK.includes(nav.title?.trim())
    );

    const allowedTitlesForUK2 = ['About', 'Support', 'Create flu360 Profile','Log in'];

    this.ukNavigation2 = (response?.children?.[0]?.children || []).filter((nav: any) =>
      allowedTitlesForUK2.includes(nav.title?.trim())
    );

    const navItems = response?.children?.[0]?.children || [];

    const allowedTitles = [
      'Prescribing Information',
      'Important Safety Information',
      'About',
      'Support',
      'Log In'
    ];

    const seenTitles = new Set();

    this.filteredNavigation = navItems.filter((nav: any) => {
      const title = nav.title?.trim();
      if (allowedTitles.includes(title) && !seenTitles.has(title)) {
        seenTitles.add(title);
        return true;
      }
      return false;
    });

    const desiredOrder = [
      'flu360<sup>®</sup> Overview',
      'Products',
      'Tools & Resources',
      'Create Account'
    ];
  
    // Sort and filter the navigation items based on desired order
    this.remainingNavigation = desiredOrder
      .map(title => navItems.find((nav: any) => nav.title?.trim() === title))
      .filter(Boolean); // removes undefined if any title is missing
    });



      
this.baseSiteService.getActive().pipe(take(1)).subscribe((baseSite: string) => {
  const baseUrl = this.config.backend?.occ?.baseUrl;
  const componentIds = ['SiteLogoComponentUK', 'SeqirusSiteLogoComponentUK'].join(',');
  const endpoint = `${baseUrl}/occ/v2/${baseSite}/cms/components?componentIds=${componentIds}&fields=FULL`;
  const UscomponentIds = ['SiteLogoComponent', 'SeqirusSiteLogoComponent'].join(',');
  const Usendpoint = `${baseUrl}/occ/v2/${baseSite}/cms/components?componentIds=${UscomponentIds}&fields=FULL`;

  this.http.get(endpoint).pipe(take(1)).subscribe((response: any) => {
    const components = response?.component ?? [];
    const logos = components
      .filter((comp: any) => comp?.media?.url)
      .map((comp: any) => comp.media)
    this.ukLogosSubject.next(logos); // Cache logos
  });
  this.http.get(Usendpoint).pipe(take(1)).subscribe((response: any) => {
    const components = response?.component ?? [];
    const logos = components
      .filter((comp: any) => comp?.media?.url)
      .map((comp: any) => comp.media)
    this.usLogosSubject.next(logos); // Cache logos
  });
});




  
}

 

   isUserregistered() {
  if (!this.multiplerun) {
    this.contentService.getnewUserData().pipe(take(1)).subscribe({
      next: (response) => {
        this.newuserData = !!response?.regSubmitted; // ensure boolean
        this.multiplerun = true;
        this.cdr.markForCheck?.();
      },
      error: () => {
        this.multiplerun = true;
        this.cdr.markForCheck?.();
      }
    });
  }
}
    

    

    ngAfterViewInit() {
      
      // this.ngZone.run(() => {
      //   setTimeout(() => {
      //     this.userInfoService.getcarttrigger().subscribe(value => {
      //       this.isCartExist= this.userInfoService.checkCartExist();
      //       this.cdr.detectChanges();
      //     });
      //   }, 2000);
      // });
 
     



    this.userInfoService.getrbaheader().subscribe(value => {
      if(value){
       // this.rbavarible=localStorage.getItem('rbapermission');
        this.rbavarible=value;
        this.cdr.detectChanges();
      }
    });

    this.userInfoService.getswitchrba().subscribe(value => {
      if(value){
        this.rbavarible=value;
        this.cdr.detectChanges();
      }
    });

    }

  updateUserData() {
   if((!this.router.url.includes('homepage') && !this.router.url.includes('login')) || this.currentSite=='seqirusb2b-flu360'){
    this.authService.isUserLoggedIn().subscribe(res=>{
      this.isUserLoggedIn=res;
      
      if(this.isUserLoggedIn){
        this.userInfoService.getUserData().pipe(shareReplay(1)).subscribe(res=>{
          if(res){
          this.userInfo=res;
          localStorage.setItem('webEnabled',  this.userInfo.webEnabled);
          this.selectedAccount = this.userInfo.orgUnit.uid;
          this.rbavarible=localStorage.getItem('rbapermission');
          this.rbavarible=JSON.parse(this.rbavarible);
          if(!this.userInfo.webEnabled){
          this.isUserregistered();
          }
          this.cdr.detectChanges();
        // this.setDifferentTopHeader();
          this.setDifferentBottomHeader();

          }
        })
        
      }
      else{
      //this.setDifferentTopHeader();
      this.setDifferentBottomHeader();
      this.cdr.detectChanges();
      }
    })
    }
  }
  updateMultipleSoldToHeader() {
    if(this.isUserLoggedIn && this.currentSite == 'seqirusb2b-uk'){
      this.userInfoService.fetchMultipleSoldToForUser().subscribe((data:any) => {
        this.multipleSoldTos = data.multipleSoldToData;
        this.filteredMultipleSoldTos=this.multipleSoldTos;
        this.cdr.detectChanges();
      })
    }
  }
    getImage(image: any): string {
      return this.config.backend?.occ?.baseUrl + image.url;
    }
    ngOnDestroy(){
      if (this.subscriptionJoinAccount) {
        this.subscriptionJoinAccount.unsubscribe(); // Prevent memory leak
      }
    }
    onRadiochange(acc:string){
      this.selectedAccount=acc;

    }
    changeAccount(){
      const href = window.location.href;
      let inPlaceOrder:any;
      this.userInfoService.getInPlaceOrder().subscribe(val => {
        inPlaceOrder = val;
      })
      if((href.includes("start-order") || href.includes("returns")) && inPlaceOrder){
        this.userInfoService.setSelectedAccount(this.selectedAccount);
        this.userInfoService.setRouteLink("switchAccount");
        this.userInfoService.setQueryParams("");
        this.userInfoService.setPopUpValue(true);
      }
      else {
        localStorage.removeItem('rbapermission');
        sessionStorage.removeItem('returnsFirstPopup');
        sessionStorage.removeItem('returnsSecondPopup');
        this.userInfoService.changeB2BAccount(this.selectedAccount).subscribe((data)=>{
        if(!this.router.url.includes('my-account')){
          this.router.navigate(['/my-account']);
        }
        else{
        const url = (this.router.url).split('?')[0].split('#')[0];
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
     
        this.router.onSameUrlNavigation = 'reload';
        this.router.navigate([url.substring(url.lastIndexOf('/')+1)]).then(()=>{
        this.cdr.detectChanges();
        });
      }
        this.userInfoService.updateUserdata();
      });
      }
    }
    filterAccount(){
      this.filteredMultipleSoldTos = this.multipleSoldTos.filter((soldTo:any )=> {
        return Object.values(soldTo).some((value:any) => value.toString().toLowerCase().includes(this.searchText.toLowerCase()));
      });
      // this.cdr.detectChanges();

    }
    toprbafunction(){
      if(this.currentSite=='seqirusb2b-uk' && this.isUserLoggedIn ){

        this.userInfoService.rbasiteflag().subscribe(data=>{

         this.rbavarible=data;
         this.cdr.detectChanges();
        });

      }

     }

     handleLinks(route: string, params: any){
      const href = window.location.href;
      let inPlaceOrder:any;
      this.userInfoService.getInPlaceOrder().subscribe(val => {
        inPlaceOrder = val;
      })
      if((href.includes("start-order") || href.includes("register") || href.includes("returns") ) && inPlaceOrder){
        this.userInfoService.setRouteLink(route);
        this.userInfoService.setQueryParams(params);
        this.userInfoService.setPopUpValue(true);
      }
      else {
        this.router.navigate([route], { queryParams: params});
        this.closeDropdown();
      }
     }
     toggleDropdown(event: Event): void {
      event.preventDefault(); // Prevent default behavior of <a> tag
      this.isDropdownOpen = !this.isDropdownOpen;
    }
    
    closeDropdown(): void {
      this.isDropdownOpen = false;
    }
    
    
  }
